export enum AlertTypes {
  IN_STOCK = 'IN_STOCK',
  PRICE_DROPS = 'PRICE_DROPS',
  IN_STOCK_PRICE_DROPS = 'IN_STOCK_PRICE_DROPS',
}

export enum ShopPreference {
  NONE = 'NONE',
  LIKED = 'LIKED',
  EXCLUDE_DISLIKED = 'EXCLUDE_DISLIKED',
}

export enum Errors {
  ERROR_EMAIL_INVALID = 'error.email.invalid',
  ERROR_EMAIL_IN_USE = 'alert.email-associated-with-user',
  ERROR_UNKNOWN = 'alert.error',
  ERROR_THRESHOLD_TOO_LOW = 'alert.threshold-too-low',
}

export interface EmailInputProps {
  error?: boolean;
}

export interface EmailHintProps extends EmailInputProps {
  visible?: boolean;
  discreetLink?: boolean;
}
